import React from 'react';
import AnchorPoint, { IAnchorPointItem } from './AnchorPoint';
import { getAllScrollTops, getContainerScrollTop, scrollTo, getElementByHref } from './utils';

interface IABSAnchorPointProps {
  getContainer?: () => HTMLElement;
  anchorPointItems: IAnchorPointItem[];
  updateAnchorPointItems?: (anchorPointItems: IAnchorPointItem[]) => void;
  height?: number;
  width?: number;
  right?: number;
  style?: any;
  id?: string;  // 锚点框id
  isStaticHide?: boolean; // 是否静止一段时间隐藏锚点框
}
export interface IABSAnchorPointState { 
  anchorPointItems: IAnchorPointItem[];
}

const SCROLL_THRESHOLD = 2;
 
class ABSAnchorPoint extends React.Component<IABSAnchorPointProps, IABSAnchorPointState> {
  scroller;
  containers: HTMLElement[] = [];
  count = 1;
  timer;

  constructor(props: any) {
    super(props);
    this.state = {
      anchorPointItems: props.anchorPointItems
    };
  }

  get scrollContainer() {
    const { getContainer } = this.props;
    if (getContainer) {
      if (getContainer() == null) {
        return document.body as HTMLElement;
      }
      return getContainer();
    }
    return document.body as HTMLElement;
  }
  componentDidMount() {
    const { getContainer } = this.props;
    const nextContainer = getContainer && getContainer();
    if (nextContainer) {
      this.setScrollProperty(nextContainer);
    }
  }

  componentDidUpdate() {
    const nextContainer = this.props.getContainer && this.props.getContainer();
    const lastContainer = this.containers[this.containers.length - 1];
    if (nextContainer && lastContainer !== nextContainer) {
      this.setScrollProperty(nextContainer);
    }
  }

  setScrollProperty = (nextContainer) => {
    const { anchorPointItems, isStaticHide } = this.props;
    const hrefs = anchorPointItems.map((item) => item.href);
    const elements = hrefs.map((href) => getElementByHref(href));
    let currentIndex = 0;
    const scrollbarEvent = (e) => {
      let allScrollTops = getAllScrollTops(elements);
      allScrollTops[allScrollTops.length] = nextContainer.scrollHeight;
      const currentScrollTop = getContainerScrollTop(nextContainer);
      const activeIndex = allScrollTops.findIndex((scrollTop) => scrollTop - SCROLL_THRESHOLD >= currentScrollTop);

      if (activeIndex !== currentIndex) {
        this.updateAnchorPointItems(activeIndex - 1 < 0 ? 0 : activeIndex - 1);
        currentIndex = activeIndex;
      }
    };
    nextContainer.removeEventListener('ps-scroll-y', scrollbarEvent);
    nextContainer.addEventListener('ps-scroll-y', scrollbarEvent);
    if (isStaticHide) {
      nextContainer.removeEventListener('ps-scroll-y', this.scrollbarlistener);
      nextContainer.addEventListener('ps-scroll-y', this.scrollbarlistener);
    }

    this.containers.push(nextContainer);
  }

  // 当滚动条不是置顶位置时，锚点框隐藏， 滚动时再显现
  scrollbarlistener = () => {
    const { id } = this.props;
    const anchorPoint: HTMLElement = document.querySelector(`${ id ? ('#' + id) : '.abs-anchor-point' }`) as HTMLElement;
    if (anchorPoint) {
      clearTimeout(this.timer);
      anchorPoint.style.display = 'block';
      if (this.scrollContainer.scrollTop !== 0 ) {
        this.timer = setTimeout(() => {
          anchorPoint.style.display = 'none';
        }, 5000);
      }
    }
  }

  onClick = (e: any, index: number) => {
    e.preventDefault();
    const { anchorPointItems } = this.props;
    const item = anchorPointItems[index];
    scrollTo(item.href, this.scrollContainer, () => {
      // 更新右侧黄点
      this.updateAnchorPointItems(index);
    });
  }

  updateAnchorPointItems(activeIndex: number) {
    const { anchorPointItems } = this.props;
    anchorPointItems.map((item, index) => {
      if (index === activeIndex) {
        item.active = true;
      } else {
        item.active = false;
      }
      return item;
    });

    this.setState({ anchorPointItems: anchorPointItems });
  }

  render() { 
    const { height, width, right, style, id, isStaticHide } = this.props;
    const { anchorPointItems }  = this.state;
    return (
      <AnchorPoint 
        height={height}
        width={width} 
        right={right}
        style={style}
        anchorPointItems={anchorPointItems} 
        onClick={this.onClick} 
        id={id}
        isStaticHide={isStaticHide}
      />
    );
  }
}

export { IAnchorPointItem };
export default ABSAnchorPoint;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAnchorPoint/index.tsx